<template>
  <section class="auth-page">
    <div class="auth-shell">
      <div class="auth-panel auth-panel--form">
        <slot name="form" />
      </div>
      <div class="auth-panel auth-panel--visual">
        <slot name="visual">
          <div class="auth-visual" aria-hidden="true">
            <img :src="chronicUrl" alt="" class="auth-visual__img" />
          </div>
        </slot>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AuthLayout',
  data() {
    return {
      chronicUrl: require('@/../assets/chronicPicture.jpg'),
    };
  },
};
</script>
<style scoped>
  .auth-page {
    --auth-blue: #cad7e6;
    --auth-blue-soft: #e3ecf6;
    --auth-sand: #efe8e1;
    --auth-ink: #0f1115;
    --auth-muted: #3c3f46;
    --auth-accent: #111111;
    --auth-accent-soft: #d6e2f2;
    min-height: 100vh;
    padding: clamp(24px, 6vw, 60px);
    background: #ffffff;
    color: var(--auth-ink);
    font-family: "Satoshi", "Montserrat", "Segoe UI", sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .auth-shell {
    width: 100%;
    max-width: 1200px;
    background: #ffffff;
    border-radius: clamp(24px, 3vw, 40px);
    box-shadow: 0 28px 60px rgba(20, 28, 40, 0.16);
    display: grid;
    grid-template-columns: minmax(320px, 1fr) minmax(280px, 0.9fr);
    overflow: hidden;
  }

  .auth-panel {
    padding: clamp(28px, 4vw, 56px);
  }

  .auth-panel--visual {
    background:
      radial-gradient(500px 320px at 20% 20%, #dbe7f6 0%, transparent 60%),
      radial-gradient(500px 320px at 70% 20%, #b8cbe3 0%, transparent 60%),
      linear-gradient(160deg, var(--auth-blue) 0%, var(--auth-blue-soft) 60%, var(--auth-sand) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
  }

  .auth-visual {
    width: 100%;
    height: 100%;
    min-height: 360px;
    border-radius: 28px;
    position: relative;
    overflow: hidden;
    box-shadow: none;
  }

  .auth-visual__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 28px;
  }

  @media (max-width: 980px) {
    .auth-shell {
      grid-template-columns: 1fr;
    }
    .auth-panel--visual {
      display: none;
    }
  }
</style>
